import { createContext } from 'react';
import { type PageCmsEditorDataQuery } from '../../../graphql/queries';

export type PanelEditorChallenge = NonNullable<PageCmsEditorDataQuery['challenges']>[number];
export type PanelEditorPage = NonNullable<NonNullable<PageCmsEditorDataQuery['pages']>[number]>;

export interface PanelEditorData {
  challenges: PanelEditorChallenge[];
  pages: PanelEditorPage[];
}

export const EMPTY_PANEL_EDITOR_DATA: PanelEditorData = { challenges: [], pages: [] };

// Link-target picker data (fetched once by the editor query), provided by EditCustomPage so the
// memoized panel tree doesn't need it threaded through props.
export const PanelEditorDataContext = createContext<PanelEditorData>(EMPTY_PANEL_EDITOR_DATA);
